import axios, { AxiosPromise } from 'axios';

const registracePotvrzeniApi = (token: string): AxiosPromise => {
    return axios({
        method: 'POST',
        url: 'Portal/Registrace/Potvrzeni',
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
};
export default registracePotvrzeniApi;
